import { useLocation } from "react-router-dom";

const useHideTemplateHeader = (routes: string[]) => {
  const location = useLocation();
  return routes.some(route => location.pathname.startsWith(route));
};

export default useHideTemplateHeader;